import Icon from '@uikit/components/Icon/Icon';
import styles from './CourseEventQuarterNavButton.module.scss';

type NavVariant = 'next' | 'prev';

type Props = {
  variant: NavVariant;
  onClick: () => void;
  disabled?: boolean;
};

const icons = {
  next: 'action/chevron-right',
  prev: 'action/chevron-left',
} as const;

const CourseEventQuarterNavButton = ({ variant, disabled, onClick }: Props) => {
  return (
    <button
      type="button"
      className={styles.navButton}
      disabled={disabled}
      onClick={onClick}
      aria-label={variant}
    >
      <Icon variant={icons[variant]} size="iconSize24" />
    </button>
  );
};

export default CourseEventQuarterNavButton;
